import { render, staticRenderFns } from "./AccountMarketingDashboardView.vue?vue&type=template&id=a069fc88"
import script from "./AccountMarketingDashboardView.vue?vue&type=script&lang=js"
export * from "./AccountMarketingDashboardView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports